import { getProductCatalogueApiConfig } from '../config/actions';
/**
 * @internal
 */
export var validateSearchParameters = function (parameters) {
    var config = getProductCatalogueApiConfig();
    if (!parameters.marketLocale) {
        parameters.marketLocale = config.marketLocale;
    }
};
